import React from "react";
import { Tabs, Tab, Box, Card, CardContent } from "@mui/material";

import { useStickyTab } from "../../../utils/uiPrefs";
import BlenderFlowDashboard from "../Lamination1/BlenderFlowDashboard";
import Lam2ExtruderDashboard from "./Lam2ExtruderDashboard";
import Lam2RollsDashboard from "./Lam2RollsDashboard";

interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box sx={{ pt: { xs: 1, md: 2 } }}>{children}</Box>}
    </div>
  );
};

const Lam2ProductionTabs: React.FC = () => {
  // Versioned key — see Lam1ProductionTabs; the tab order changed.
  const [tab, setTab] = useStickyTab("lam2.v2", 3);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Card sx={{ m: { xs: 1, md: 2 } }}>
      <CardContent sx={{ p: { xs: 1, md: 2 } }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tab}
            onChange={handleChange}
            aria-label="Lamination 2 production tabs"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab
              label="Rolls"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
            <Tab
              label="Extruders"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
            <Tab
              label="Blenders"
              sx={{ minWidth: "auto", px: { xs: 1, md: 2 } }}
            />
          </Tabs>
        </Box>

        <TabPanel value={tab} index={0}>
          <Lam2RollsDashboard />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <Lam2ExtruderDashboard />
        </TabPanel>

        <TabPanel value={tab} index={2}>
          <BlenderFlowDashboard
            blenderOptions={[
              { id: "3", label: "Blender A", hasFlow3: true },
              { id: "4", label: "Blender B", hasFlow3: false },
            ]}
          />
        </TabPanel>
      </CardContent>
    </Card>
  );
};

export default Lam2ProductionTabs;
